import React, { createContext, useContext, useState } from 'react';

export const FilterContext = createContext({});

const FilterProvider = ({ children }) => {
  const [skillValue, setSkillValue] = useState("");
  const [statusValue, setStatusValue] = useState("");

  return (
    <FilterContext.Provider value={{skillValue, setSkillValue, statusValue, setStatusValue}}>
      {children} 
    </FilterContext.Provider> 
  );
}

const useFilter = () => {
  const ctx = useContext(FilterContext);

  if (!ctx) {
    throw new Error('useFilter must be used within an AuthProvider');
  }

  return ctx;
}


export { FilterProvider, useFilter };
